<template>
  <div class="fee-template">
    <loading :isShow="loading" />
    <div class="top-box">
      <div class="title-text">
        {{ query.mechanName }}—{{ query.productName }}
        <span class="tag gray" v-if="query.publishStatus == '1'">已下架</span>
        <span class="tag red" v-if="query.isTemplate == '0' && query.showRateTag && query.id != userInfo.organId">独立费率</span>
      </div>
      <div class="header">
        <span>产品编码： {{ query.productCode || '-' }}</span>
        <span>保司：{{ query.companyName || '-' }}</span>
        <span v-if="$units.superviseShowVal() && $units.pointAction('commission_10_6')">供应商：{{ query.supplierName || '-' }}</span>
      </div>
      <div class="activity-box">
        <div class="activity-name" v-for="(item, index) in data.activityInfoList" :key="index" v-if="item.mode == 1 || query.isTop">
          <img class="activity-icon" src="@/static/images/activity-icon.png" />
          <span class="name active-name" @click="openPageTabTags('/activityManage/detail', { id: item.id, mode: item.mode, actType: item.actType })"
            >活动{{ index + 1 == 1 ? '①' : '②' }}：{{ item.title }}</span
          >
          <span>{{ filterTime(item.startTime, 'YYYY-MM-DD') }}至{{ filterTime(item.endTime, 'YYYY-MM-DD') }}</span>
          <img class="activity-right" src="@/static/images/activity-right.png" />
        </div>

        <div class="activity-name" v-if="data && data.merchantActivity">
          <img class="activity-icon" src="@/static/images/activity-icon.png" />
          <span class="name"
            >活动{{ !data.activityInfoList || !data.activityInfoList.filter(item => item.mode != 2).length ? '①' : '②' }}：{{
              data.merchantActivity.name
            }}</span
          >
          <span>{{ filterTime(data.merchantActivity.startTime, 'YYYY-MM-DD') }}至{{ filterTime(data.merchantActivity.endTime, 'YYYY-MM-DD') }}</span>
        </div>
      </div>
      <Button type="primary" ghost @click="backPage">返回</Button>
    </div>
    <Tabs v-model="tabId" :animated="false" @on-click="tabChange" v-if="$units.pointAction('commission_10_3') && query.sourceType == 2">
      <TabPane label="当前费率" name="1"></TabPane>
      <TabPane label="其他版本费率" name="2"></TabPane>
    </Tabs>
    <!-- 无tab占位 -->
    <div class="station-box" v-else></div>

    <div v-if="tabId == '1'" class="btnBox clearfix">
      <div class="fir">
        <div class="version-wrap left">
          <span v-if="data.versionNo"> 有效期：{{ data.versionStartTime || '-' }} 至 {{ data.versionEndTime || '-' }}</span>
        </div>
        <div v-if="tabId == '1' && organShow && data && data.commissionItems">
          <Button type="primary" v-show="!showEdit" class="edit-btn" @click="edit">编辑</Button>
          <Button type="primary" ghost v-show="showEdit" class="edit-btn" @click="cancel">取消</Button>
          <Button type="primary" v-show="showEdit" class="edit-btn left" @click="saveClcik">保存</Button>
        </div>
      </div>
    </div>
    <!-- 当前费率 -->
    <rate-table
      v-show="tabId == '1'"
      ref="rateTable"
      :isEditAuth="$units.pointAction('commission_10_1')"
      :data="data"
      :type="query.nodeType"
      :mode="organShow ? 'one' : 'base'"
      @save="openConfirmModal"
      @hideEdit="showEdit = false"
      :pageType="query.pageType"
      :isTop="query.isTop"
    ></rate-table>
    <!-- 历史费率 -->
    <version-list ref="versionList" v-show="tabId == '2'" :organShow="organShow" :query="query" @callback='editFutureVersion'></version-list>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal" @save="save"></confirm-modal>
  </div>
</template>

<script>
import rateTable from '@/components/commons/feeTemplate/rateTable';
import versionList from './components/versionList';
import confirmModal from '@/components/commons/feeTemplate/confirmModal';
import { common } from '@/api/mixins';
import { filterTime } from '@/api/filter';

export default {
  mixins: [common],
  components: { rateTable, versionList, confirmModal },
  data() {
    return {
      filterTime,
      tabId: '1',
      loading: false,
      showEdit: false,
      data: {},
      userInfo: {},
      query: {},
      detaile: {},
      version: {}, //版本信息
      organShow: true
    };
  },
  async activated() {
    this.query = this.$route.query;
    this.showEdit = false;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.organShow = JSON.parse(this.$route.query.organShow);
    this.tabChange();
    this.$nextTick(() => {
      this.querySupplyInfos();
    });
  },
  methods: {
    querySupplyInfos() {
      this.$http({
        url: '/buz/upcommission/querySupplyInfos',
        type: 'GET',
        data: {
          productCode: this.query.productCode
        }
      }).then(res => {
        this.query.companyName = res.data.companyName;
        this.query.supplierName = res.data.supplierName;
      });
    },
    actTitleNumber(index) {
      let orderIndex = index + 1;
      if (this.data.activityInfoList.length == 1) return;
      switch (orderIndex) {
        case 1:
          return '①';
        case 2:
          return '②';
      }
    },
    // 切换tab
    tabChange() {
      if (this.tabId == '1') {
        this.getData();
      } else if (this.tabId == '2') {
        this.$refs.versionList.getData();
      }
    },
    editFutureVersion(row) {
      if (!this.$units.pointAction('commission_10_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$router.push({
        path: '/productResource/fee/rateHistoryDetailNew',
        query: {
          ...this.query,
          versionNo: row.versionNo,
          versionType: row.versionType
        }
      });
    },
    // 编辑按钮点击
    edit() {
      if (!this.$units.pointAction('commission_10_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.showEdit = true;
      this.$refs.rateTable.showEdit();
    },
    // 取消按钮点击
    cancel() {
      this.$refs.rateTable.hideEdit();
    },
    // 保存按钮点击
    saveClcik() {
      this.$refs.rateTable.save();
    },
    // 打开确认弹窗
    openConfirmModal(data) {
      this.$refs.confirmModal.open(data);
    },
    // 保存费率
    save(data) {
      if (this.loading) {
        return;
      }
      console.log(data);
      this.loading = true;
      let params = {};

      params = {
        id: this.query.id,
        nodeType: this.query.nodeType,
        productCode: this.query.productCode,
        isTemplate: this.query.isTemplate,
        commissionList: data.list
      };

      this.$http({
        url: '/buz/productBase/modify/commission',
        type: 'post',
        data: params
      })
        .then(res => {
          this.showEdit = false;
          this.$notice.success('保存费率成功');
          this.loading = false;
          if (this.query.isTemplate == 1) {
            var rou = this.$router.resolve({
              query: {
                ...this.query,
                isTemplate: 0
              }
            });
            this.back(rou.href);
          } else {
            this.getData();
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 获取费率数据
    getData() {
      this.$http({
        url: '/buz/productBase/query/commissionVersion',
        type: 'post',
        data: {
          id: this.query.id,
          nodeType: this.query.nodeType,
          productCode: this.query.productCode,
          isTemplate: this.query.isTemplate
        }
      }).then(res => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
    backPage() {
      if (this.query.workName == 'workName') {
        this.back('/workbench/index');
      } else {
        localStorage.setItem('updataOrgAndTeam', 1);
        this.back('/productResource/fee/config');
      }
    }
  }
};
</script>
<style lang="scss">
@import './rateDetail.scss';

.version-wrap {
  margin-bottom: 10px;
}
</style>
